export const ContactSideBarMenu: any[] = [
  {
    label: "Basic Information",
    url: "/contacts/view/:contact_id/basic-information",
    isDisabled: false,
    isAvailable: true, //if we want dynamic rendering the pass the correct moduleId and make isAvailable = false
    moduleId: "contacts",
    parentModuleId: "contacts",
    value: "basic-information",
  },
  {
    label: "Communication Stats",
    url: "/contacts/view/:contact_id/communication-stats",
    isDisabled: false,
    isAvailable: true, //if we want dynamic rendering the pass the correct moduleId and make isAvailable = false
    moduleId: "contacts",
    parentModuleId: "contacts",
    value: "communication-stats",
  },
  {
    label: "Activities",
    url: "/contacts/view/:contact_id/activities/tasks",
    isDisabled: false,
    isAvailable: true, //if we want dynamic rendering the pass the correct moduleId and make isAvailable = false
    moduleId: "contacts",
    parentModuleId: "contacts",
    value: "tasks",
  },
  {
    label: "Files",
    url: "/contacts/view/:contact_id/files",
    isDisabled: false,
    isAvailable: true, //if we want dynamic rendering the pass the correct moduleId and make isAvailable = false
    moduleId: "contacts",
    parentModuleId: "contacts",
    value: "files",
  },
 ];

// export const ContactSideBarMenu: any;

export const ContactSideBarMenuPrivate = [
  {
    label: "Woocommerce",
    url: "/contacts/view/:contact_id/woocommerce/order-details",
    isDisabled: false,
    isAvailable: false, //if we want dynamic rendering the pass the correct moduleId and make isAvailable = false
    moduleId: "woocommerce_enabled",
    parentModuleId: "contacts",
    value: "woocommerce",
  },
  {
    label: "Shopify",
    url: "/contacts/view/:contact_id/shopify/order-details",
    isDisabled: false,
    isAvailable: false, //if we want dynamic rendering the pass the correct moduleId and make isAvailable = false
    moduleId: "shopify_enabled",
    parentModuleId: "contacts",
    value: "shopify",
  },
];
